<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div>
      <div class="table-page-search-wrapper">
        <a-form :form="form" layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="名称">
                <a-input
                  placeholder="输入名称查询"
                  v-model="queryParam.name"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item label="性别">
                <a-select v-model="queryParam.gender" placeholder="请选择性别">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">男性</a-select-option>
                  <a-select-option value="2">女性</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <!-- 标签 -->
            <!-- TODO -->
            <a-form-item
              v-if="false"
              label="标签 "
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-search
                placeholder="点击选择标签"
                v-model="queryParam.tag"
                readOnly
                @search="viewLabel('5')"
              >
                <a-button slot="enterButton" icon="search">选择</a-button>
              </a-input-search>
            </a-form-item>

            <a-col :md="6" :sm="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项&nbsp;&nbsp;
          <a style="margin-left: 24px" @click="clearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          bordered
          size="middle"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          :rowKey="r => r.userid + r.external_contact.external_userid"
          @change="handleTableChange"
        >
          <template slot="avatarslot" slot-scope="text, record">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getAvatarView(record.external_contact.avatar)"
                icon="user"
              />
            </div>
          </template>
          <span slot="tag" slot-scope="text, record">
            <a v-if="!record.tagInfo">--</a>
            <a-tag
              color="#108ee9"
              v-for="item in record.tagInfo.name"
              :key="item"
              v-else
              >{{ item }}</a-tag
            >
          </span>
        </a-table>
      </div>
    </div>

    <div class="drawer-bootom-button" style="text-align: right">
      <!--
      <a-popconfirm title="确定放弃编辑？" @confirm="handleCancel" okText="确定" cancelText="取消">
        <a-button style="margin-right: .8rem" >取消</a-button>
      </a-popconfirm> -->
      <a-button @click="send" type="primary" :loading="confirmLoading"
        >群发</a-button
      >
    </div>
  </a-card>
</template>

<script>
import { postTag, getFileAccessHttpUrl } from '@/api/manage';
import { frozenBatch, emptyLabel, getContactByCus } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';

export default {
  name: 'wxCustomerSendList',
  mixins: [JeecgListMixin],
  data: function() {
    return {
      form: this.$form.createForm(this),
      byCus: '',
      description: '这是企业微信销售管理页面',
      queryParam: {
        userId: this.$route.query.userId,
        tag: ''
      },
      selectedRowKeys: [],
      allSelectedRows: [],
      external_userid: '',
      records: [],
      view: {
        other: '',
        avatar: '',
        name: '',
        gender: '',
        type: '',
        phone: '',
        corp_name: '',
        grade: '',
        hobby: '',
        label: ''
      },
      labels: [],
      columns: [
        {
          title: '客户名称',
          align: 'center',
          width: 100,
          dataIndex: 'external_contact.name'
        },
        {
          title: '客户头像',
          align: 'center',
          width: 180,
          dataIndex: 'external_contact.avatar',
          scopedSlots: {
            customRender: 'avatarslot'
          }
        },
        {
          title: '标签',
          dataIndex: 'tag',
          scopedSlots: {
            customRender: 'tag'
          },
          align: 'center',
          width: 200
        },
        {
          title: '性别',
          align: 'center',
          width: 100,
          dataIndex: 'external_contact.gender',
          customRender: function(text, record, index) {
            if (text === 1) {
              return '男性';
            } else if (text === 2) {
              return '女性';
            } else {
              return '无';
            }
          }
        },
        {
          title: '是否发送',
          align: 'center',
          width: 100,
          dataIndex:
            'currentCustomerIsSuccessReceiveAppointGroupSendMaterialMessage',
          customRender: function(text, record, index) {
            if (text) {
              return '已发送';
            } else {
              return '未发送';
            }
          }
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/client/data/justThis'
      },
      confirmLoading: false,
      selectedRows: []
    };
  },
  computed: {
    // selectedcount() {
    //   return this.allSelectedRows.length < 1 ? 0 : this.allSelectedRows.map(e => e.selectedRows.length).reduce((a,
    //     b) => a + b)
    // }
  },
  watch: {
    // 'ipagination.current': function () {
    //   this.selectedRowKeys = this.allSelectedRows[this.ipagination.current] ? this.allSelectedRows[this.ipagination
    //     .current].selectedRows : []
    // },
  },
  // inject: ['reload'],
  props: {
    value: String
  },
  methods: {
    send() {
      if (this.selectedRowKeys.length == 0) {
        // console.log(1111);
        this.$message.warning('请选择客户、客户群！');
        return false;
      }
      console.log(
        this.selectedRowKeys,
        this.selectedRows,
        this.allSelectedRows
      );
      this.confirmLoading = true;
      let userIds = [];
      // for (const pi in this.selectedRows) {
      // const p = this.selectedRows[pi]
      // console.log(p, p.selectedRows, Array.isArray(p.selectedRows))
      // p && p.selectedRows && p.selectedRows.
      this.selectedRows.forEach(e => {
        if (userIds.indexOf(e.external_contact.external_userid) == -1) {
          userIds.push(e.external_contact.external_userid);
        }
      });
      // }

      postTag(
        process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/createGroupMsg',
        {
          chatType: '0',
          id: this.value,
          userIds
        }
      )
        .then(res => {
          console.log(res);
          if (res.success) {
            this.close();
            this.$message.success('发送成功');
            this.selectedRowKeys = [];
          } else {
            this.$message.warning(res.message);
            this.selectedRowKeys = [];
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
          this.$message.error('发送失败');
        });
    },
    clearSelected() {
      this.allSelectedRows = [];
      this.selectedRowKeys = [];
      this.onClearSelected();
    },
    onSearch() {},
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.allSelectedRows = this.allSelectedRows.concat(selectedRows);
      this.selectedRows = this.selectedRows.concat(selectedRows);
      // this.$set(this.allSelectedRows, this.ipagination.current, {
      //   selectedRowKeys,
      //   selectedRows
      // })
      // this.allSelectedRows.forEach(e=>{
      //   e.selectedRowKeys.forEach(item=>{
      //     this.selectedRowKeys.push(item)
      //     this.selectedRowKeys=[...new Set(this.selectedRowKeys)]
      //   })
      // })
      console.log(
        this.allSelectedRows,
        this.ipagination.current,
        this.selectedRowKeys
      );
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    viewLabel(key) {
      this.$refs.customerWindow.add(key, this.selectedRowKeys);
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.form.resetFields();
      this.selectedRowKeys = [];
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
